// A signboard, described the way age-of-mcp authors it: a `post` helper for the
// wooden post and the shared `foundationSlab` for the base, walked through its
// build stages. Ported 1:1 from age-of-mcp's sign.ts.
import * as THREE from "three";
import { defineModel, foundationSlab, type Part } from "../../lib";

const POST = "#7a5a32";
const BOARD = "#b9904f";

// A wooden post `h` tiles tall.
function post(h: number): Part {
  return {
    geometry: new THREE.BoxGeometry(0.04, h, 0.04),
    color: POST,
    position: [0, h / 2, 0],
  };
}

// The build stages of the sign: foundation, sprouting post, taller post, and
// the finished post carrying its written board.
function partsFor(s: number): Part[] {
  if (s <= 0) return [foundationSlab(0.18, 0.05)];
  if (s === 1) return [post(0.16)];
  if (s === 2) return [post(0.3)];
  return [
    post(0.36),
    { geometry: new THREE.BoxGeometry(0.26, 0.16, 0.03), color: BOARD, position: [0, 0.32, 0] },
  ];
}

export const sign = defineModel({
  id: "sign",
  tiles: { w: 1, h: 1 },
  batchId: "standard",
  name: "Sign",
  tags: ["building","sign","low-poly","age-of-mcp","classic"],
  summary: "Low-poly sign.",
  description: "A wooden board carrying one short written message.",
  author: "age-of-mcp",
  footprint: 0.13,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
